import { Subject as n } from "rxjs";
import { merge as c } from "lodash-es";
var a = /* @__PURE__ */ ((t) => (t[t.rollup = 0] = "rollup", t[t.webpack = 1] = "webpack", t))(a || {}), e = /* @__PURE__ */ ((t) => (t.ADMIN = "admin", t.CARY = "cary", t.LOOPIA = "loopia", t.ACTIVE_24 = "active24", t))(e || {});
const r = new n(), i = r.asObservable(), o = {
  // default config values
  companyCountry: "SK",
  bounds: {
    east: 16.8799829444,
    south: 47.7584288601,
    west: 22.5581376482,
    north: 49.5715740017
  },
  languages: {},
  currency: "EUR",
  validationApiUrl: "https://api-cart.websupport.sk/",
  bundler: a.webpack
};
function b(t) {
  c(o, t), r.next(o);
}
export {
  a as Bundler,
  e as Theme,
  o as config,
  i as configObservable,
  b as setConfigValues
};
//# sourceMappingURL=index.es.js.map
